<section class="video-carousel-panel"
         #panelEl>

  <div class="video-carousel-panel__content">

    <h2 *ngIf="data.title"
        class="video-carousel-panel__header">{{ data.title.value }}</h2>
    <div *ngIf="data.description"
         class="video-carousel-panel__description"
         [innerHTML]="data.description.value"></div>

    <div class="mobile-dropdown"
         (click)="toggleDropdownState()">
      <div class="mobile-dropdown__arrow"
           [ngClass]="{'mobile-dropdown__arrow--opened' : dropdownOpened === dropdownStates.opened}"></div>
      <div *ngFor="let item of items; let i = index;"
           class="mobile-dropdown__container"
           [ngClass]="{'mobile-dropdown__container--opened' : dropdownOpened === dropdownStates.opened}">
        <div [@dropdown]="item.dropdown"
             (click)="dropdownClick(item, i)">
          <p class="mobile-dropdown__header"
             [ngClass]="{'mobile-dropdown__header--active' : item.state === videoStates.active}">{{ item.title.value }}
          </p>
        </div>
      </div>
    </div>

    <div class="video-carousel-panel__tabs">
      <div class="video-carousel-panel__top"
           *ngFor="let item of items; let i = index;">
        <div class="video-carousel-panel__card"
             (click)="cardClick(item, i)"
             [ngClass]="{'video-carousel-panel__card--active': item.state === videoStates.active}">
          <div>
            <p class="video-carousel-panel__card--header"
               [ngClass]="{'video-carousel-panel__card--header--inactive' : item.state === videoStates.inactive}">
              {{ item.title.value }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="video-carousel-panel__wrapper">
      <div>
        <div *ngFor="let item of items; let i = index;">
          <div class="video-carousel-panel__animation"
               [ngClass]="{'video-carousel-panel__animation--inactive': item.state === videoStates.inactive}">
            <div *ngIf="item.state === videoStates.active">
              <div *ngIf="item.videoData.video.type === 2 && loadMedia">
                <video preload="true"
                       autoplay="autoplay"
                       [loop]="isClicked"
                       [muted]="'muted'"
                       name="media"
                       (ended)="nextItem()"
                       class="video-carousel-panel__animation--content">
                  <source [src]="item.videoData.video.url"
                          type="video/mp4">
                </video>
              </div>
              <div *ngIf="item.videoData.video.type !== 2">
                <div class="video-carousel-panel__animation--iframe-box"></div>
                <app-iframe class="video-carousel-panel__animation--content video-carousel-panel__animation--content-iframe"
                            [src]="item.videoData.video.url"
                            (onended)="nextItem()">
                </app-iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
